import { Flex, View, TextField, Link, DialogTrigger, ActionButton, Dialog, Content, NumberField } from "@adobe/react-spectrum";
import { ComponentRowData } from "../ComponentRelations";
import { AlertIconFill, TrashIcon } from "../../../../../components/protected/Icons/IconsLib";
import ProductDropDown from "./ProductsDropDown";
import ItemCategoryDropDown from "./ItemCategoryDropDown";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useViewInfo } from "../../../../../hooks/UseViewInfo";

interface IProductComponentLineAddEditProps {
    id?: string;
    defaultRowData: {};
    selectedRowData: ComponentRowData;
    handleRowClose: () => void;
    addRecord: (record: any) => void;
    updateRecord: (record: any) => void;
    deleteRecord: (record: any) => void;
    closeDialog: (isOpen: boolean) => void;
    styles: any;
}

const ProductComponentLineAddEdit: React.FC<IProductComponentLineAddEditProps> = ({
    id,
    defaultRowData,
    selectedRowData,
    handleRowClose,
    addRecord,
    updateRecord,
    deleteRecord,
    closeDialog,
    styles
}) => {
    const [selectedRow, setSelectedRow] = useState<ComponentRowData>(selectedRowData || defaultRowData);
    const [validationMessages, setValidationMessages] = useState<any>({ component: '', category: '', purchasePrice: '', countMin: '', countMax: '' });
    const { t } = useTranslation('products');
    const _t = (key: string) => t(`product_common.${key}`, { ns: 'products' });
    const _tt = (key: string) => t(`product_messages.${key}`, { ns: 'products' });
    const { isMobile } = useViewInfo();

    useEffect(() => {
        setValidationMessages(
            selectedRowData.component !== ''
                ? { component: '', category: '', purchasePrice: '', countMin: '', countMax: '' }
                : { component: 'required', category: '', purchasePrice: '', countMin: '', countMax: '' }
        );
        setSelectedRow(selectedRowData || defaultRowData);
    }, [id, selectedRowData]);

    const validateFields = () => !['component', 'category', 'purchasePrice', 'countMin', 'countMax'].some(field => validationMessages[field] !== '');

    const validateAndSubmit = () => {
        // if (!validateFields()) return;
        //console.log('selectedRowData', selectedRowData);
        const action = (selectedRowData && Number(selectedRowData.component) !== 0) || Number(selectedRowData.component) !== 0 ? updateRecord : addRecord;
        closeDialog(false);
        action(selectedRow);
    };

    return <> {isMobile || window.innerWidth < 1030 ? (
        <Flex direction={'column'} gap={'size-200'} marginTop={'size-200'}>
            <ProductDropDown
                selectedProduct={selectedRow.component || ''}
                onChange={(data) => {
                    setSelectedRow(prev => ({
                        ...prev, component: data.id.toString(),
                        componentName: data.name,
                        componentCategory: data.componentCategory || '',
                        componentCategoryName: data.componentCategoryName || '',
                        purchasePrice: data.purchasePrice
                    }));
                }}
                isRequired={true}
                errorMessage={''}
                validationState={''}
                setProductType={(data) => {

                }}
            />
            <TextField
                label={'Component Name'}
                aria-label={'Component Name'}
                value={selectedRow.componentCategoryName || ''}
                width={'100%'}
                isReadOnly />
            <NumberField
                label={'Purchase Price'}
                aria-label={'Purchase Price'}
                isReadOnly
                value={selectedRow.purchasePrice ? +selectedRow.purchasePrice : undefined}
                onChange={(value) => setSelectedRow(prev => ({ ...prev, purchasePrice: value.toString() }))}
                width={'100%'}
            />
            <NumberField
                label={'Ratio'}
                aria-label={'Ratio'}
                value={selectedRow.ratio ? +selectedRow.ratio : undefined}
                onChange={(value) => setSelectedRow(prev => ({ ...prev, ratio: value.toString() }))}
                width={'100%'}
            />
            <NumberField
                label={'Count Min'}
                aria-label={'Count Min'}
                value={selectedRow.countMin ? +selectedRow.countMin : undefined}
                onChange={(value) => setSelectedRow(prev => ({ ...prev, countMin: value.toString() }))}
                width={'100%'}
            />
            <NumberField
                label={'Count Max'}
                aria-label={'Count Max'}
                value={selectedRow.countMax ? +selectedRow.countMax : undefined}
                onChange={(value) => setSelectedRow(prev => ({ ...prev, countMax: value.toString() }))}
                width={'100%'}
            />
            <TextField
                label={'Note'}
                aria-label={'Note'}
                value={selectedRow.note || ''}
                onChange={(value) => setSelectedRow(prev => ({ ...prev, note: value }))}
                width={'100%'}
            />
        </Flex>
    ) : (
        <>
            <table className="spectrum-Table" style={{ marginTop: '20px' }} cellSpacing={0}>
                <thead className="spectrum-Table-head">
                    <tr>
                        <th style={{ width: '30%' }} className="spectrum-Table-headCell">
                            <span className="spectrum-Table-headCellLabel">
                                <ProductDropDown
                                    selectedProduct={selectedRow.component || ''}
                                    onChange={(data) => {
                                        setSelectedRow(prev => ({
                                            ...prev, component: data.id.toString(),
                                            componentName: data.name,
                                            componentCategory: data.componentCategory || '',
                                            componentCategoryName: data.componentCategoryName || '',
                                            purchasePrice: data.purchasePrice
                                        }));
                                    }}
                                    isRequired={true}
                                    errorMessage={''}
                                    validationState={''}
                                    setProductType={(data) => {

                                    }}
                                />
                            </span>
                        </th>
                        <th className="spectrum-Table-headCell">
                            <span className="spectrum-Table-headCellLabel">
                                <TextField
                                    aria-label={'Component Name'}
                                    value={selectedRow.componentCategoryName || ''}
                                    isReadOnly />
                            </span>
                        </th>
                        <th className="spectrum-Table-headCell">
                            <span className="spectrum-Table-headCellLabel">
                                <NumberField
                                    aria-label={'Purchase Price'}
                                    isReadOnly
                                    value={selectedRow.purchasePrice ? +selectedRow.purchasePrice : undefined}
                                    onChange={(value) => setSelectedRow(prev => ({ ...prev, purchasePrice: value.toString() }))}
                                />
                            </span>
                        </th>
                        <th className="spectrum-Table-headCell">
                            <span className="spectrum-Table-headCellLabel">
                                <NumberField
                                    aria-label={'Ratio'}
                                    value={selectedRow.ratio ? +selectedRow.ratio : undefined}
                                    onChange={(value) => setSelectedRow(prev => ({ ...prev, ratio: value.toString() }))}
                                />
                            </span>
                        </th>
                        <th className="spectrum-Table-headCell">
                            <span className="spectrum-Table-headCellLabel">
                                <NumberField
                                    aria-label={'Count Min'}
                                    value={selectedRow.countMin ? +selectedRow.countMin : undefined}
                                    onChange={(value) => setSelectedRow(prev => ({ ...prev, countMin: value.toString() }))}
                                />
                            </span>
                        </th>
                        <th className="spectrum-Table-headCell">
                            <span className="spectrum-Table-headCellLabel">
                                <NumberField
                                    aria-label={'Count Max'}
                                    value={selectedRow.countMax ? +selectedRow.countMax : undefined}
                                    onChange={(value) => setSelectedRow(prev => ({ ...prev, countMax: value.toString() }))}
                                />
                            </span>
                        </th>
                        <th className="spectrum-Table-headCell">
                            <span className="spectrum-Table-headCellLabel">
                                <TextField
                                    aria-label={'Note'}
                                    value={selectedRow.note || ''}
                                    onChange={(value) => setSelectedRow(prev => ({ ...prev, note: value }))}
                                />
                            </span>
                        </th>
                    </tr>
                </thead>
            </table>
        </>
    )
    }
        <Flex direction={{ base: 'column', L: 'row' }} justifyContent={'end'} gap={'size-175'} marginTop={'size-200'}>
            <Flex>
                {(selectedRowData.component) !== '' && (
                    <Flex>
                        <DialogTrigger isDismissable type="modal">
                            <ActionButton UNSAFE_className={styles.btn_delete}>{_t('button_remove')}</ActionButton>
                            {close => (
                                <Dialog size="S">
                                    <Flex UNSAFE_className={styles.delete_pop_up_parent}>
                                        <Content UNSAFE_className={styles.delete_pop_up_header}>{_tt('remove_component_line')} </Content>
                                        <View UNSAFE_className={styles.delete_pop_up_line}></View>
                                        <View UNSAFE_className={styles.delete_pop_up_warning_text}>{_tt('are_you_sure_you_want_to_remove')}</View>
                                        <View UNSAFE_className={styles.buttons_parent}>
                                            <View UNSAFE_className={styles.button_cancel}>
                                                <Link UNSAFE_className={styles.delete_pop_up_cancel_text} isQuiet onPress={close}>
                                                    {_t('button_keep')}
                                                </Link>
                                            </View>
                                            <View UNSAFE_className={styles.button_confirm}>
                                                <div className={styles.trash_icon}>
                                                    <TrashIcon size={32} />
                                                </div>
                                                <Link UNSAFE_className={styles.delete_pop_up_confirm_text} isQuiet onPress={() => deleteRecord(selectedRow)}>
                                                    {_t('button_remove')}
                                                </Link>
                                            </View>
                                        </View>
                                        <View UNSAFE_className={styles.ellipse_div}>
                                            <View UNSAFE_className={styles.delete_alert_icon}>
                                                <AlertIconFill size={72} />
                                            </View>
                                        </View>
                                    </Flex>
                                </Dialog>
                            )}
                        </DialogTrigger>
                    </Flex>
                )}
            </Flex>
            <Flex direction={{ base: 'row', L: 'row' }} gap={'size-200'}>
                <Flex>
                    <Link UNSAFE_className={styles.btn_cancel} isQuiet onPress={handleRowClose}>
                        {_t('button_cancel')}
                    </Link>
                </Flex>
                <Flex>
                    <Link UNSAFE_className={styles.btn_confirm} isQuiet onPress={() => validateAndSubmit()}>
                        {selectedRowData.component === ''? _t('button_add') : _t('button_update')}
                    </Link>
                </Flex>
            </Flex>
        </Flex>
    </>
}

export default ProductComponentLineAddEdit;